import axios from 'axios';

// 从环境变量或本地存储中获取后端API的基础URL
const getBaseUrl = () => {
  const storedBaseUrl = localStorage.getItem('api_base_url');
  if (storedBaseUrl) {
    return storedBaseUrl;
  }
  // 当部署到Spring Boot后，API路径为/api
  return '/api';
};

// 创建axios实例
const api = axios.create({
  baseURL: getBaseUrl(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器，添加认证令牌
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器，处理常见错误
api.interceptors.response.use(
  (response) => {
    // 记录成功响应
    console.debug('API响应:', response.config.url, response.status, response.data);
    return response;
  },
  (error) => {
    // 记录错误详情
    console.error('API错误:', 
      error.config?.url, 
      error.response?.status, 
      error.response?.data || error.message
    );

    if (error.response) {
      // 服务端返回的错误状态码
      const { status, data } = error.response;
      
      if (status === 401) {
        console.warn('认证失败，清除登录状态');
        // 清除登录信息
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
      } else if (status === 403) {
        console.warn('没有权限访问资源');
      } else if (status >= 500) {
        console.error('服务器错误:', data?.message || '未知服务器错误');
      }
    }
    return Promise.reject(error);
  }
);

// 设置/更新API基础URL
export const setBaseUrl = (url: string) => {
  localStorage.setItem('api_base_url', url);
  api.defaults.baseURL = url;
};

export default api; 